<template>
	<div id="layout-admin" class="px-lg-3">
		<header id="header" style="margin-bottom: 1rem;">
			<div class="container-fluid">

				<div class="row justify-content-between">
					<div class="col-auto">

						<router-link :to="{ name: 'dashboard' }">
							<img class="logo" src="/images/logo_alt.webp" alt="Zikipro">
						</router-link>

					</div>
					<div class="col-auto text-end">
						<router-link class="btn btn-outline-primary btn-sm" :to="{ name: 'admin.dashboard' }">
							Area di amministrazione
						</router-link>

					</div>
				</div>

			</div>
		</header>
		<main id="main">
			<div class="container-fluid">
				<div v-if="$slots.title">
					<slot name="title" />
				</div>

				<div class="py-4">
                    <slot />
                </div>
			</div>
		</main>

		<ZikiFooter />
	</div>
</template>

<script>
export default {
	name: "LayoutAdmin",
};
</script>
<style scoped>
#layout-admin {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

main {
    flex: 1;
}
</style>
